import { Component, OnInit } from '@angular/core';
import { GlobalServiceService } from '../global-service.service';

@Component({
  selector: 'app-our-services',
  templateUrl: './our-services.component.html',
  styleUrls: ['./our-services.component.css']
})
export class OurServicesComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.328;
  constructor(private service: GlobalServiceService) { }

  ngOnInit(){
    this.onResize();
  }

  onResize(){
    let width = $(window).width();
    if (width > 800) {
      this.height = this.service.getHeight(this.proportion);
    } else {
      this.height = this.service.getHeight(this.proportion) * 1.2;
    }

  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/about us/our-services.component.ts